import { render, staticRenderFns } from "./order_deliver_detail.vue?vue&type=template&id=05d23064&scoped=true"
import script from "./order_deliver_detail.vue?vue&type=script&lang=js"
export * from "./order_deliver_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d23064",
  null
  
)

export default component.exports